import { capitalize } from '@sonar-software/sonar-ts-lib';
import { FilterComponent } from './FilterComponent';
import { getDirectParent } from '@lib/popups';
import { getFilterId } from '@ui/table-modifier/@arch/lib';
import React from 'react';

import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { FilterOption, OptionFilter } from '@periscopes/general/filters';

export const PopulatedValues = {
	isNullValue: COPY_SPECIFIC.EMPTY,
	notNullValue: COPY_SPECIFIC.POPULATED
};

const options: Array<FilterOption> = [
	{
		label: COPY_SPECIFIC.EMPTY,
		value: PopulatedValues.isNullValue
	},
	{
		label: COPY_SPECIFIC.POPULATED,
		value: PopulatedValues.notNullValue
	}
];

export const Populated: FilterComponent<string | null | undefined> = (props) => {
	const { format, id, label, onChange, value } = props;

	return (
		<FilterComponent
			{ ...props }
			tagProps={ {
				clearValue: undefined,
				value: options.find((option) => option.value === value)?.label
			} }>
			<OptionFilter
				className='filter'
				getPopupContainer={ getDirectParent }
				id={ getFilterId(id) }
				onChange={ (populated: string | null) =>
					onChange({
						[ id ]: {
							format,
							value: populated
						}
					}) }
				options={ options }
				placeholder={ PLACEHOLDERS_COPY.FILTER_BY(capitalize(label)) }
				showArrow
				value={ value } />
		</FilterComponent>
	);
};
